import React from 'react';
import { useTranslation } from 'react-i18next';

export type ViewMode = 'grid' | 'list';

interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
  className?: string;
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  currentView,
  onViewChange,
  className = '',
}) => {
  const { t } = useTranslation();

  return (
    <div className={`flex items-center bg-white rounded-lg border border-gray-300 p-1 ${className}`}>
      <button
        onClick={() => onViewChange('grid')}
        className={`flex items-center justify-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
          currentView === 'grid'
            ? 'bg-blue-600 text-white shadow-sm'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
        }`}
        aria-label={t('dashboard.views.grid', { defaultValue: 'Grid view' })}
        title={t('dashboard.views.grid', { defaultValue: 'Grid view' })}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" 
          />
        </svg>
        <span className="ml-2 hidden sm:inline">
          {t('dashboard.views.grid', { defaultValue: 'Grid' })}
        </span>
      </button>
      
      <button
        onClick={() => onViewChange('list')}
        className={`flex items-center justify-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
          currentView === 'list'
            ? 'bg-blue-600 text-white shadow-sm'
            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
        }`}
        aria-label={t('dashboard.views.list', { defaultValue: 'List view' })}
        title={t('dashboard.views.list', { defaultValue: 'List view' })}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M4 6h16M4 10h16M4 14h16M4 18h16" 
          />
        </svg>
        <span className="ml-2 hidden sm:inline">
          {t('dashboard.views.list', { defaultValue: 'List' })}
        </span>
      </button>
    </div>
  );
};

export default ViewToggle;